import _ from 'lodash';

const core_mixin = {
    methods: {
        isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        setKeyInTo: function(obj, which, what, callback) {
            if(_.isString(obj)) {
                this[obj] = which
            } else {
                obj[which] = what
            }
            if(callback && typeof callback === 'function') {
                callback();
            }
        },
        copy(text, silent, coordinates) {
            text = text.toString();
            const that = this;
            const t = document.getElementById('tempInput');
            t.innerHTML = text;
            t.select();
            try {
                const successful = document.execCommand('copy');
                const msg = successful ? 'successfully' : 'unsuccessfully';
                // success
                if(!silent) {
                    that.makeFlyout(this.getTranslate('copied'), coordinates);
                }
            } catch (err) {
                // error
            }
            t.innerHTML = '';
        },
        getMouseCoordinates(e, offset = false) {
            e = e || window.event;
            if(!e) {
                return false;
            }
            if (e.pageX == null && e.clientX !== null) {
                const html = document.documentElement;
                const body = document.body;

                e.pageX = e.clientX + ((html && html.scrollLeft) || (body && body.scrollLeft) || 0) - (html.clientLeft || 0);
                e.pageY = e.clientY + ((html && html.scrollTop) || (body && body.scrollTop) || 0) - (html.clientTop || 0)
            }
            if(e.pageX && e.pageY) {
                if (!offset) {
                    return {
                        x: e.pageX,
                        y: e.pageY,
                        elem: document.elementFromPoint(e.pageX, e.pageY) || false
                    }
                } else {
                    return {
                        x: e.pageX - e.offsetX,
                        y: e.pageY - e.offsetY,
                        elem: document.elementFromPoint(e.pageX, e.pageY) || false
                    }
                }
            } else {
                return false;
            }
        },
        makeFlyout(text, coordinates) {
            delete this.workflowData.meta.flyout_o;
            if(this.workflowData.meta.flyout_o_t) {
                clearTimeout(this.workflowData.meta.flyout_o_t);
                delete this.workflowData.meta.flyout_o_t;
            }
            let c = false;
            if(coordinates) {
                c = coordinates;
            } else {
                c = this.getMouseCoordinates();
            }
            this.workflowData.meta.flyout_o = {
                x: c.x,
                y: c.y - 20,
                text: text
            };
            const that = this;
            const to = setTimeout(() => {
                delete this.workflowData.meta.flyout_o;
            }, 500);
            this.workflowData.meta.flyout_o_t = to;
        },
        openCarrot() {
            if(!this.is_intl) {
                if(window.jivo_api) window.jivo_api.open()
            } else window.open('https://t.me/rerada_support_bot')
        },
    },
    computed: {
        is_intl() {
            let intl = false;
            intl = document.location.hostname.includes(atob('cmVyYWRhLmNvbQ=='));
            return intl;
        },
    }
};

export default core_mixin
